import React from 'react';

import { getColor } from 'containers/RiskAssessmentsDetails/RiskMatrix/styles';

import { StyledRiskMatrixSummary, StyledRiskMatrixSummaryItem, StyledRiskMatrixSummaryItemValue } from './styles';
import { RiskMatrixSummaryProps } from './types';

export const RiskMatrixSummary: React.FC<RiskMatrixSummaryProps> = ({
  selectedImpact,
  selectedLikelihood,
  selectedRisk,
  matrixRows,
  matrixColumns,
}) => {
  const { color, bg } = getColor(selectedImpact, selectedLikelihood, matrixRows, matrixColumns);

  return (
    <StyledRiskMatrixSummary>
      <StyledRiskMatrixSummaryItem>Selected Impact: {selectedImpact}</StyledRiskMatrixSummaryItem>
      <StyledRiskMatrixSummaryItem>Selected Likelihood: {selectedLikelihood}</StyledRiskMatrixSummaryItem>
      <StyledRiskMatrixSummaryItemValue color={color} backgroundColor={bg}>
        Risk Score: {selectedRisk}
      </StyledRiskMatrixSummaryItemValue>
    </StyledRiskMatrixSummary>
  );
};
